"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transparentize = transparentize;
exports.color = exports.colors = void 0;

var _props = require("./props");

var _color = _interopRequireDefault(require("color"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Export `colors`.
 */

/**
 * Export `transparentize`.
 */
function transparentize(value, transparency) {
  return (0, _color.default)(value).alpha(transparency).rgb().string();
}
/**
 * Export `colors`.
 */


var colors = {
  black: '#000',
  white: '#fff'
};
/**
 * Export `color`.
 */

exports.colors = colors;

var color = function color(colorName) {
  return (0, _props.themeProp)("colors.".concat(colorName));
};
/**
 * Transparentize theme color.
 */


exports.color = color;

color.transparentize = function (colorName, transparency) {
  return function (props) {
    var colorValue = color(colorName)(props);
    return transparentize(colorValue, transparency);
  };
};